import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.83051 13.2407C9.47107 13.654 10.2344 13.8341 10.9921 13.7507C11.7498 13.6674 12.4557 13.3257 12.9911 12.7831L13.4592 12.3254C13.6644 12.1155 13.7793 11.8336 13.7793 11.5401C13.7793 11.2465 13.6644 10.9646 13.4592 10.7547L11.4725 8.78885C11.2644 8.58429 10.9842 8.46967 10.6924 8.46967C10.4006 8.46967 10.1204 8.58429 9.91227 8.78885V8.78885C9.70238 8.99405 9.4205 9.10895 9.12695 9.10895C8.83341 9.10895 8.55153 8.99405 8.34163 8.78885L5.22116 5.66837C5.11706 5.56579 5.0344 5.44353 4.97798 5.30871C4.92155 5.17389 4.8925 5.0292 4.8925 4.88305C4.8925 4.7369 4.92155 4.59221 4.97798 4.45739C5.0344 4.32257 5.11706 4.20032 5.22116 4.09773V4.09773C5.42571 3.88959 5.54033 3.60944 5.54033 3.31761C5.54033 3.02579 5.42571 2.74563 5.22116 2.53749L3.24486 0.561194C3.03496 0.355987 2.75308 0.241089 2.45954 0.241089C2.166 0.241089 1.88412 0.355987 1.67422 0.561194L1.21655 1.02927C0.673949 1.56468 0.332245 2.27059 0.248896 3.02831C0.165547 3.78603 0.345636 4.54934 0.758882 5.1899C2.91206 8.36314 5.65172 11.0957 8.83051 13.2407V13.2407Z"
    }, null, -1)
  ])))
}
export default { render: render }